import { StrictMode } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { useErrorBoundary } from 'use-error-boundary';

import { Callback } from './Callback';
import { Login } from './Login';
import { Logout } from './Logout';
import { Unauthorized } from './Unauthorized';
import { UserBlocked } from './UserBlocked';
import { ErrorPage } from './ErrorPage';
import { MainLayoutPage } from './MainLayoutPage';

import { Providers } from 'providers';
import { APP_ROOT, CALLBACK, ERROR, LOGIN, LOGOUT, UNAUTHORISED, USER_BLOCKED } from 'routes';
import { AppStatus } from 'components';
import { ProtectedRoute } from 'routes/ProtectedRoute';

export const App = () => {
  const { ErrorBoundary, didCatch } = useErrorBoundary({
    onDidCatch(_exception) {
      // log exceptions in Application Insights
    },
  });

  return (
    <StrictMode>
      <Providers>
        <BrowserRouter>
          {didCatch ? (
            <ErrorPage userUnavailable />
          ) : (
            <ErrorBoundary>
              <AppStatus>
                <Routes>
                  <Route path={CALLBACK} element={<Callback />} />
                  <Route path={LOGIN} element={<Login />} />
                  <Route path={LOGOUT} element={<Logout />} />
                  <Route element={<ProtectedRoute />}>
                    <Route path={UNAUTHORISED} element={<Unauthorized />} />
                  </Route>
                  <Route element={<ProtectedRoute />}>
                    <Route path={USER_BLOCKED} element={<UserBlocked />} />
                  </Route>
                  <Route element={<ProtectedRoute />}>
                    <Route path={ERROR} element={<ErrorPage />} />
                  </Route>
                  <Route element={<ProtectedRoute />}>
                    <Route path={`${APP_ROOT}*`} element={<MainLayoutPage />} />
                  </Route>
                </Routes>
              </AppStatus>
            </ErrorBoundary>
          )}
        </BrowserRouter>
      </Providers>
    </StrictMode>
  );
};
